import commonPasswordsList from "../commonPasswordsList";

const commonPassword = (checkPassword: string) =>
  commonPasswordsList.some((password) => password === checkPassword);

export default commonPassword;
